import { TitleSubtitle } from "@redotech/redo-model/widget";
import { Button, ButtonTheme } from "@redotech/redo-web/button";
import { Text } from "@redotech/redo-web/text";
import * as classNames from "classnames";
import * as cbCss from "./checkout-buttons.module.css";

export const CheckoutButtons = ({
  onCoverageCheckoutClick,
  onClickNoCoverage,
  coveragePrice,
  cartTotal,
  customCss,
  coverageButtonText,
  nonCoverageButtonText,
  dataTarget,
}: {
  onCoverageCheckoutClick: () => void;
  onClickNoCoverage: () => void;
  coveragePrice: number;
  cartTotal: number;
  customCss?: string;
  coverageButtonText?: TitleSubtitle;
  nonCoverageButtonText?: string;
  dataTarget?: string;
}) => {
  return (
    <>
      {customCss ? <style>{customCss}</style> : null}

      <div
        className={cbCss.fullContainer}
        data-target={dataTarget || "checkout-buttons-container"}
      >
        <Button
          bgColor={undefined}
          className={classNames(cbCss.container, cbCss.blue)}
          dataTarget="coverage-button"
          onClick={onCoverageCheckoutClick}
          theme={ButtonTheme.PRIMARY}
          w="full"
        >
          <>
            <Text color="white" fontSize="md" w="full">
              {coverageButtonText?.titleText ||
                `Complete Checkout | $${(coveragePrice + cartTotal).toFixed(2)}`}
            </Text>
            <Text color="white" fontSize="xxs" w="full">
              {coverageButtonText?.subtitleText ||
                "Return shipping and protection included"}
            </Text>
          </>
        </Button>

        <a
          className={classNames(cbCss.textWrap, cbCss.linkButton)}
          color="black"
          data-target="non-coverage-button"
          onClick={onClickNoCoverage}
        >
          <Text
            className={classNames(cbCss.textWrap)}
            color="black"
            fontSize="xxs"
          >
            {nonCoverageButtonText ||
              `Or checkout for $${cartTotal.toFixed(2)}. Return shipping and protection not included`}
          </Text>
        </a>
      </div>
    </>
  );
};
